module.exports = __webpack_public_path__ + "img/icon_pingpailiaojie_home.361d77af.png";